<template>
    <g>
        <path d="M0.666992 0.333252L6.00033 5.66659L11.3337 0.333252" :fill="iconFill" />
    </g>
</template>
<script>
export default {
    name: "ArrowDown",
    props: {
        iconFill: {
            type: String,
            default: "#206CFF",
        },
    },
};
</script>
